import { store } from '../index';

export default {
  state: {
    data: {
      step: 1,
      maxStep: 3,
      complete: false,
      error: '',
      /** done because of 2 different locations of call (1. Auto - by page url and 2. From click) */
      autoOpen: false,
      choice: {},
    },
  },
  mutations: {
    'club/setData'(state, payload) {
      try {
        state.data = {
          ...payload,
        };
      } catch (err) {
        console.error(err);
      }
    },
    'club/setChoice'(state, payload) {
      try {
        const { table, value, i } = payload;
        state.data.choice[table] = {
          [i]: value,
        };

        // state.data.choice[table] = {
        // ...state.data.choice[table],
        // [i]: value
        // };

        // state.data.choice[table] = {
        //     ...state.data.choice[table],
        //     [i]: value
        // };
      } catch (err) {
        console.error(err);
      }
    },
    'club/setAutoOpen'(state, payload) {
      try {
        state.data.autoOpen = payload;
      } catch (err) {
        console.error(err);
      }
    },
    // ['club/delChoice'] (state, payload) {
    //     try {
    //         const { table, value, i } = payload;
    //         console.log(state.data.choice[table])
    //         state.data.choice[table] = state.data.choice[table].splice(i,1,value);
    //     } catch (err) {
    //         console.error(err);
    //     }
    // },
    // ['club/setStep'] (state, payload) {
    //     try {
    //         state.data.step = payload;
    //     } catch (err) {
    //         console.error(err);
    //     }
    // },
  },
  actions: {
    async 'club/getDataByStep'({ state: { data }, commit, getters, dispatch, rootState }, payload) {
      try {
        commit('global/loaderStart');

        const choice = data?.choice;
        const choiceKeys = Object.keys(choice);
        const choiceValues = Object.values(choice);
        /**
         * if user don't chose picture - show error
         */
        if (choiceKeys.length < payload - 1) {
          commit('club/setData', {
            ...data,
            ...{
              error: rootState?.results?.messages?.sovaClub?.chosePicture,
            },
          });
          commit('global/loaderStop');
          return;
        }

        /**
         * mechanic of sending request for creating Bitrix highload-block field by user choice
         */
        if (payload > data.maxStep) {
          const item = getters['club/getItem'];
          const requestData = {
            UF_IBLOCK_ELEMENT: item.id,
          };
          for (let i = 0; i < choiceKeys.length; i++) {
            const hlValues = Object.values(choiceValues[i]);
            for (let index = 0; index < hlValues.length; index++) {
              requestData[`UF_TABLE_NAME_${i + 1}`] = choiceKeys[i];
              requestData[`UF_XML_ID_${i + 1}`] = hlValues[index];
            }
          }
          await dispatch('club/addClubSubscribe', requestData);
          commit('global/loaderStop');
          return;
        }
        /**
         * standard mechanic of transition to the next step
         */
        const { status, data: responseData } = await axios.get(location.href, {
          params: {
            ...getters.getRequestLang,
            step: payload,
            apiClub: 'y',
          },
        });
        if (status !== 200) throw `Bad request response status: ${status}`;

        /**
         * @todo do method of clear errors
         */
        commit('club/setData', {
          ...responseData,
          step: payload,
          ...{
            choice: data.choice,
            maxStep: data.maxStep,
            autoOpen: data.autoOpen,
          },
        });
        commit('global/loaderStop');
      } catch (err) {
        console.error(err);
      }
    },
    async 'club/addClubSubscribe'({ state: { data }, commit }, payload) {
      try {
        const { path, action } = data.routes.addClubSubscribe;
        payload.action = action;

        const { status, data: responseData } = await axios.post(path, payload);
        console.log(responseData);
        if (status !== 200) throw `Bad request response status: ${status}`;

        commit('club/setData', { ...data, ...responseData });
      } catch (err) {
        console.error(err);
      }
    },
    // async ['club/updateChoice']({state, commit, getters}, payload) {
    //     try {
    //         if (getters['club/inChoice']) {
    //             commit('club/delChoice', payload)
    //         } else {
    //             commit('club/setChoice', payload)
    //         }
    //
    //     } catch (err) {
    //         console.error(err);
    //     }
    // },
  },
  getters: {
    'club/inChoice': (state) => (table, value, i) => {
      try {
        let values = [];
        let keys = [];

        const choice = state?.data?.choice?.[table];
        if (choice) {
          keys = Object.keys(choice);
          values = Object.values(choice);
        }
        return !!values.find((el) => el == value) && !!keys.find((el) => el == i);
      } catch (err) {
        console.log(err);
      }
    },
    'club/getItemByPageUrl': (state) => {
      try {
        return state?.data?.items?.find((el) => el?.isShowOnThisPage) ?? {};
      } catch (err) {
        console.log(err);
      }
    },
    'club/getItemByFooterMenuLink': (state) => {
      try {
        return state?.data?.items?.[0];
      } catch (err) {
        console.log(err);
      }
    },
    'club/getItem': (state, getters) => {
      try {
        return state?.data?.autoOpen
          ? getters['club/getItemByPageUrl']
          : getters['club/getItemByFooterMenuLink'];
      } catch (err) {
        console.log(err);
      }
    },
  },
};
